
import request from '../request'

//查询
export function queryMyMarkList() {
    return request({
        url: '/mark/queryMyMarkList',
        method: 'get',
        data: {}
    })
}

//删除
export function deleteMark(id) {
    return request({
        url: '/mark/deleteMark?id='+id,
        method: 'get',
        data: {}
    })
}


//根据deleteByMarkId删除
export function deleteByMarkId(markId) {
    return request({
        url: '/mark/deleteByMarkId?markId='+markId,
        method: 'get',
        data: {}
    })
}

//保存标绘
export function createMark(data){
    return request({
        url: '/mark/createMark',
        method: 'post',
        data: data
    })
}

//修改标绘
export function updateMark(data){
    return request({
        url: '/mark/updateMark',
        method: 'post',
        data: data
    })
}